'use client'

import useApp from '@/lib/store'
import { FC, useEffect } from 'react'

interface KeyboardShortcutsProps {}

const KeyboardShortcuts: FC<KeyboardShortcutsProps> = ({}) => {
	const { setIsContactOpen } = useApp()

	useEffect(() => {
		function listenForEscapeKey(event: KeyboardEvent) {
			const key = event.key
			if (key == 'Escape') {
				setIsContactOpen(false)
			}
		}
		window.addEventListener('keyup', listenForEscapeKey, false)
		return () => window.removeEventListener('keyup', listenForEscapeKey, false)
	}, [])

	return null
}
export default KeyboardShortcuts
